module.exports = __webpack_public_path__ + "static/banner-3629bcda942ea45f11960b3ef03ee30d.jpeg";